/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IOrganism } from 'app/shared/model/organism.model';
import { IAntibiotic } from 'app/shared/model/antibiotic.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface ILabTestItemOrganismAntibiotic {
  id?: string;
  suggestedBy?: string | null;
  micSusceptible?: number | null;
  micIntermediate?: number | null;
  micResistant?: number | null;
  notes?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  source?: IClinicalDictionary | null;
  labTestItem?: ILabTestItem | null;
  organism?: IOrganism | null;
  antibiotic?: IAntibiotic | null;
  lab?: IDiagLab | null;
}

export const defaultValue: Readonly<ILabTestItemOrganismAntibiotic> = {
  active: false,
};
